import { DialogTrigger } from "@indietabletop/appkit";
import { EditMode } from "../../engine/EditMode.ts";
import {
  MenuDialogDisclosure,
  MenuSeparator,
  MoreMenu,
} from "../ActionsMenu/ActionsMenu.tsx";
import { EditVehicleDialog } from "../VehicleFormDialog/VehicleFormDialog.tsx";
import { DeleteVehicleDialog } from "./DeleteVehicleDialog.tsx";
import { DuplicateVehicleDialog } from "./DuplicateVehicleDialog.tsx";
import { ModelContext } from "./ModelContext.tsx";
import { useVehicle } from "./useVehicle.tsx";

export function VehicleActionsMenu() {
  const { vehicle, readOnly } = useVehicle();

  if (!vehicle || readOnly) {
    return null;
  }

  return (
    <ModelContext value={vehicle}>
      <MoreMenu>
        <DialogTrigger>
          <EditVehicleDialog />
          <MenuDialogDisclosure>Edit</MenuDialogDisclosure>
        </DialogTrigger>

        {vehicle.can(EditMode.CHANGE, "models") && (
          <>
            <DialogTrigger>
              <DuplicateVehicleDialog />
              <MenuDialogDisclosure>Duplicate</MenuDialogDisclosure>
            </DialogTrigger>

            <MenuSeparator />

            <DialogTrigger>
              <DeleteVehicleDialog />
              <MenuDialogDisclosure>Delete</MenuDialogDisclosure>
            </DialogTrigger>
          </>
        )}
      </MoreMenu>
    </ModelContext>
  );
}
